import React from 'react'
import styled from 'styled-components';
import Redirect from '../components/Redirect';

const Home = () => {
    return (
        <HomeContainer>
            <Redirect/>
        </HomeContainer>
    )
}

const HomeContainer = styled.div`
    flex: 4;
`

export default Home